export * from './src/automations-triggercatalog-v1-trigger-trigger-catalog.schemas.js';
